module.exports = __webpack_public_path__ + "static/img/hero-cv-5.e3fb308.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web-firehero/tw/pc/imgs/hero-cv-5.png
// module id = aPm/
// module chunks = 13